"use client";

/* eslint-disable no-restricted-imports */
import {
  type Experiment as _Experiment,
  FeatureString as _FeatureString,
  IfFeatureEnabled as _IfFeatureEnabled,
  useFeatureIsOn as _useFeatureIsOn,
  useFeatureValue as _useFeatureValue,
  useGrowthBook as _useGrowthBook,
} from "@growthbook/growthbook-react";
/* eslint-enable no-restricted-imports */
import type { ReactNode } from "react";

import type { AppFeatures } from "@/types/features.generated";

type FeatureKey = keyof AppFeatures;

export interface Experiment<T> extends _Experiment<T> {
  key: FeatureKey;
}

export const useGrowthBook = _useGrowthBook<AppFeatures>;
export const useFeatureIsOn = _useFeatureIsOn<AppFeatures>;

export const useFeatureValue = <
  ID extends FeatureKey,
  Fallback extends AppFeatures[ID],
>(
  id: ID,
  fallback: Fallback,
) => _useFeatureValue(id, fallback);

export const FeatureString = (props: {
  default: string;
  feature: FeatureKey;
}) => _FeatureString(props);

interface IfFeatureEnabledProps {
  children: ReactNode;
  feature: FeatureKey;
}

export const IfFeatureEnabled = (props: IfFeatureEnabledProps) =>
  _IfFeatureEnabled(props);

export const IfFeatureEnabledElse = ({
  children,
  elseUI = null,
  feature,
}: { elseUI?: ReactNode } & IfFeatureEnabledProps) => {
  const featureEnabled = useFeatureIsOn(feature);

  return <>{featureEnabled ? children : elseUI}</>;
};
